import { useState, useRef } from "react";

const OtpInput = ({
  length = 6,
  onComplete,
  isWrong = false,
  onChange,
  disabled,
  onSubmit,
}) => {
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const inputRefs = useRef([]);

  const handleChange = (index, value) => {
    const cleanValue = value.replace(/\s/g, "");

    if (cleanValue !== "" && isNaN(cleanValue)) return;

    const newOtp = [...otp];
    newOtp[index] = cleanValue.substring(cleanValue.length - 1);
    setOtp(newOtp);

    if (value && index < length - 1) {
      inputRefs.current[index + 1]?.focus();
    }

    if (newOtp.every((digit) => digit !== "")) {
      onComplete?.(newOtp.join(""));
    } else {
      onComplete?.(null);
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === " " || e.code === "Space") {
      e.preventDefault();
      return;
    }

    if (e.key === "Enter") {
      e.preventDefault();
      onSubmit?.();
      return;
    }

    if (e.key === "ArrowLeft" && index > 0) {
      e.preventDefault();
      inputRefs.current[index - 1]?.focus();
      return;
    }

    if (e.key === "ArrowRight" && index < length - 1) {
      e.preventDefault();
      inputRefs.current[index + 1]?.focus();
      return;
    }

    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text");
    const cleanPaste = paste.replace(/\s/g, "");
    const pasteArray = cleanPaste.split("").slice(0, length);

    if (pasteArray.every((char) => !isNaN(char) && char !== "")) {
      const newOtp = [...otp];
      pasteArray.forEach((char, index) => {
        if (index < length) {
          newOtp[index] = char;
        }
      });
      setOtp(newOtp);

      const nextIndex = Math.min(pasteArray.length, length - 1);
      inputRefs.current[nextIndex]?.focus();

      if (newOtp.every((digit) => digit !== "")) {
        onComplete?.(newOtp.join(""));
      } else {
        onComplete?.(null);
      }
    }
  };

  return (
    <div className="az-otp-container">
      {otp.map((digit, index) => (
        <input
          key={index}
          ref={(el) => (inputRefs.current[index] = el)}
          type="text"
          inputMode="numeric"
          maxLength="1"
          value={digit}
          onChange={(e) => {
            handleChange(index, e.target.value);
            onChange?.();
          }}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onPaste={handlePaste}
          className={`${isWrong ? "wrong" : ""} az-otp-input ${digit ? "filled" : ""}`}
          disabled={disabled}
        />
      ))}
    </div>
  );
};

export default OtpInput;
